import { HTTP_CP_ListSignInCompanies_Response_Company } from '@api-new/authservice';
import { HTTP_CP_LoadSignInBranding_Response } from '@api-new/companyservice';
import { createSelector } from '@ngrx/store';
import { AppState } from '@shared/models/app-state.model';
import { AuthState } from './auth.state';
import { PendingSignInModel } from './models/pending-sign-in.model';
import { isSignInCodeRejectedReason } from './utils/is-sign-in-code-rejected-reason';

export const selectAuthState = (state: AppState): AuthState => state.auth;

export const selectAuthLoading = createSelector(selectAuthState, (state: AuthState) => (state != null ? state.loading : false));

export const selectIsLoginFromParamsOrBrandingLoading = createSelector(
  selectAuthState,
  (state: AuthState) => state.loadingActions.isLoginFromParamsLoading || state.loadingActions.isLoadingBranding,
);

export const selectRedirectUrl = createSelector(selectAuthState, (state: AuthState): string => state.redirectUrl);

export const selectPendingSignIn = createSelector(selectAuthState, (state: AuthState): PendingSignInModel | null => state.pendingSignIn);

export const selectSignInCompanyId = createSelector(selectAuthState, (state: AuthState): string | null => state.signInCompanyId);

export const selectSignInEmail = createSelector(selectAuthState, (state: AuthState): string => state.email);

export const selectLastTimeVerificationCodeSent = createSelector(
  selectAuthState,
  (state: AuthState): Date => state.lastTimeVerificationCodeSent,
);

export const selectIsNewCodeSent = createSelector(selectAuthState, (state: AuthState): boolean => state.isNewCodeSent);

export const selectNoEmailFoundError = createSelector(selectAuthState, (state: AuthState): { noEmailFound: boolean } => {
  // Returning object on purpose to be emitted on each change
  return {
    noEmailFound: state.doesEmailExist === false,
  };
});

export const signInErrorCode = createSelector(selectAuthState, (state: AuthState): string => state.errorCode);

export const isIncorrectSignInCode = createSelector(selectAuthState, (state: AuthState): boolean =>
  isSignInCodeRejectedReason(state.errorCode),
);

export const selectLastSignInCode = createSelector(selectAuthState, (state: AuthState): string => state.lastSignInCode);

export const selectIsSendingVerificationCode = createSelector(
  selectAuthState,
  (state: AuthState): boolean => state.loadingActions.isSendingVerificationCode,
);

export const selectBranding = createSelector(
  selectAuthState,
  (state: AuthState): HTTP_CP_LoadSignInBranding_Response | null => state.branding,
);

export const selectIsLoadingBranding = createSelector(
  selectAuthState,
  (state: AuthState): boolean => state.loadingActions.isLoadingBranding,
);

export const selectSignInCompanies = createSelector(
  selectAuthState,
  (state: AuthState): HTTP_CP_ListSignInCompanies_Response_Company[] => state.signInCompanies,
);

export const selectIsCheckingLoginEmail = createSelector(
  selectAuthState,
  (state: AuthState): boolean => state.loadingActions.isCheckingLoginEmail,
);

export const selectIsLoadingSignInCompanies = createSelector(
  selectAuthState,
  (state: AuthState): boolean => state.loadingActions.isLoadingSignInCompanies,
);
